import request from '@/utils/request'
import store from '@/store'

const sharedApi = process.env.VUE_APP_SHARED_API

// 根据业务fileId获取文件（只有一个附件，如企业logo，用户头像场景）
export function getFileUrlByFileIdApi(params) {
  const fileIdMap = store.state.authFile?.fileIdMap || {}
  const fileInfo = fileIdMap[params.attachmentId] || {}
  if (fileInfo.attachmentId) {
    return new Promise((resolve) => {
      resolve({
        data: {
          ...fileInfo,
          external: fileInfo.downloadUrl
        }
      })
    })
  }
  return request(
    {
      url: sharedApi + `/attachments/${params.attachmentId}/access-url`,
      method: 'get'
    },
    { needLoading: false }
  )
}

// html 转 pdf
export function htmlToPdfApi(data) {
  return request({
    url: sharedApi + `/resource-tools/html-to-pdf`,
    method: 'post',
    data: { ...data, platform: process.env.VUE_APP_PLATFORM_CONSTANT },
    responseType: 'arraybuffer'
  })
}
